import { forwardRef } from 'react'
import { Button as MuiButton, ButtonProps as MuiButtonProps, SvgIcon } from '@mui/material'

import { isHappa } from '@/hooks'

export type ButtonProps = MuiButtonProps & { icon?: string }

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = 'contained',
      color = 'primary',
      icon,
      endIcon,
      href,
      size = 'medium',
      sx,
      ...props
    },
    ref
  ) => {
    return (
      <MuiButton
        ref={ref}
        href={href}
        variant={variant}
        color={color}
        endIcon={endIcon}
        startIcon={
          icon ? (
            <SvgIcon fontSize="medium">
              <use href={`#ico-${icon}`} />
            </SvgIcon>
          ) : null
        }
        size={size}
        disableElevation
        sx={{
          typography: 'menu',
          textTransform: 'none',
          height: '4.8rem',
          px: (theme) => theme.spacing(3),
          borderRadius: (theme) =>
            isHappa ? theme.shape.borderRadius1 : theme.shape.borderRadius360,
          '.MuiButton-startIcon': {
            mr: '0.8rem',
            ml: 0,
            '& svg': {
              fontSize: '1.6rem !important'
            }
          },
          ...sx
        }}
        {...props}
      >
        {children}
      </MuiButton>
    )
  }
)

export default Button
